import React from "react";
import { ArrowLeft } from "lucide-react";

import { Button } from "@/components/ui/button";

export default function BackToDashboardButton({
  onClick,
  className = "",
  variant = "outline",
}) {
  return (
    <Button
      type="button"
      variant={variant}
      size="sm"
      onClick={onClick}
      className={`gap-2 ${className}`}
      data-testid="back-to-dashboard-button"
    >
      <ArrowLeft className="h-4 w-4" />
      Tableau de bord
    </Button>
  );
}
